import { render, staticRenderFns } from "./LocalSiiSettings.vue?vue&type=template&id=39a6e8f5&"
import script from "./LocalSiiSettings.vue?vue&type=script&lang=js&"
export * from "./LocalSiiSettings.vue?vue&type=script&lang=js&"
import style0 from "./LocalSiiSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports